import { z } from 'zod';

/**
 * Deposer dans la Boite : du texte, une photo, ou les deux (la photo + une legende).
 *
 * La photo arrive deja REDIMENSIONNEE par l'application (grand cote ~1568 px, JPEG) :
 * la limite d'octets ci-dessous est un garde-fou serveur, pas la norme. Partage
 * API/application pour que le message affiche a l'envoi soit la regle appliquee.
 */
export const deposerSchema = z
  .object({
    text: z.string().trim().max(4000, 'Le message est trop long').default(''),
    /** Contenu base64 (sans prefixe data:). ~2 Mo d'image au maximum. */
    imageBase64: z
      .string()
      .max(2_800_000, 'La photo est trop lourde — réessaie, elle sera réduite')
      .optional(),
    imageMimeType: z.enum(['image/jpeg', 'image/png', 'image/webp']).optional(),
  })
  .refine((v) => v.text !== '' || v.imageBase64 !== undefined, {
    message: 'Dis-moi quelque chose, ou joins une photo',
  })
  .refine((v) => (v.imageBase64 === undefined) === (v.imageMimeType === undefined), {
    message: 'Photo incomplète',
  });

export type DeposerInput = z.infer<typeof deposerSchema>;
